import { ActionTaken, Channel, MessageInterface, TranscriptPayload } from "@swivl-mono/types";
import { Body, Path, Put } from "tsoa";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Messages/Messages.Controller.ts
export class MessagesAPI {
  static getAllMessages(orgId: number, userId: number, channel?: Channel) {
    return APIService.Server.get<MessageInterface[]>(`/messages/org/${orgId}/user/${userId}`);
  }

  public static async saveActionTaken(orgId: number, uuid: string, payload: ActionTaken) {
    return APIService.Server.put<boolean>(`/messages/org/${orgId}/message/${uuid}/action-taken`, payload);
  }

  static saveMessage(message: Partial<MessageInterface>) {
    return APIService.Server.post<MessageInterface>(`/messages/org/${message.orgId}`, message);
  }

  static getTranscriptText(orgId: number, userId: number, channel: Channel, numberOfMessages: number) {
    return APIService.Server.get<string>(`/messages/org/${orgId}/user/${userId}/transcript/channel/${channel}/message-count/${numberOfMessages}`);
  }
  static getMessagesForGPTTranscript(orgId: number, userId: number, channel: Channel, numberOfMessages: number, olderThan?: string) {
    const payload = olderThan ? { olderThan } : undefined;

    return APIService.Server.get<string>(
      `/messages/org/${orgId}/user/${userId}/gpt-transcript/channel/${channel}/message-count/${numberOfMessages}`,
      payload
    );
  }

  static getPastMessages(orgId: number, userId: number, token: string, limit: number = 20) {
    return APIService.Server.get<MessageInterface[]>(`/messages/org/${orgId}/user/${userId}/token/${token}/limit/${limit}`);
  }

  static getMessagesForTranscript(userId: number, channel?: Channel) {
    let query = {};
    if (channel) {
      (query as any).channel = channel;
    }
    return APIService.Server.get<TranscriptPayload>(`/messages/user/${userId}/transcript`, query);
  }
}
